'use client';

import { type PropsWithChildren, createContext, useCallback, useContext, useState } from 'react';
export enum MODAL {
  LOGIN = 'login',
  REGISTER = 'register',
  INFO = 'info',
  FORGOT = 'forgot',
  SEARCH = 'search',
  CHAT = 'chat',
  PROFILE = 'profile',
  TRANSACTION_DETAIL = 'transaction_detail',
  WALLET = 'wallet',
  COUPONS = 'coupons',
  KYC = 'kyc',
  VERIFY_EMAIL = 'verify_email',
  CHAT_RULES = 'chat_rules',
  VERIFY_PROFILE = 'verify_profile',
  SHARE = 'share',
  BUNKER = 'bunker',
  VERIFY_PASS = 'verify_pass',
  BUNKER_SUCCESS = 'bunker_success',
}
export type ModalActionContextProps = {
  openModal: MODAL | null;
  setOpenModal: (modal: MODAL | null, data?: string) => void;
  modalData?: string;
};
const ModalActionContext = createContext<ModalActionContextProps | null>(null);
export const ModalActionProvider: React.FC<PropsWithChildren> = ({
  children
}) => {
  const [openModal, handleOpenModal] = useState<MODAL | null>(null);
  const [modalData, setModalData] = useState<string>();
  const setOpenModal = useCallback((modal: MODAL | null, data?: string) => {
    handleOpenModal(modal);
    setModalData(modal ? data : undefined);
  }, []);
  return <ModalActionContext.Provider value={{
    openModal,
    setOpenModal,
    modalData
  }}>
      {children}
    </ModalActionContext.Provider>;
};
export const useModalAction = () => {
  const context = useContext(ModalActionContext);
  if (!context) {
    throw new Error('useModalAction must be used within a ModalActionProvider');
  }
  return context;
};